import { INVOICE_MODAL_TYPES } from "../../InvoiceModal/InvoiceModalContent";
import { PaymentStatus, Vehicle } from "../../Interfaces/vehicle.type";
import getVehicleDataPush from "../getVehicleDataPush";

const getInvoiceModalEventLabel = (invoiceType: PaymentStatus) => {
  if (
    invoiceType === INVOICE_MODAL_TYPES.PAYMENT_DUE.case ||
    invoiceType === INVOICE_MODAL_TYPES.PAYMENT_FAILED.case
  ) {
    return "pay-invoice";
  }
  return "view-invoice";
};

const openInvoiceModalDataPush = (
  vehicle: Vehicle,
  invoiceType: PaymentStatus
) => {
  const vehicleDataPush = getVehicleDataPush(vehicle);
  //@ts-ignore
  if (window.digitalData) {
    //@ts-ignore
    return digitalData.push({
      event: {
        name: "click",
        category: "button",
        label: getInvoiceModalEventLabel(invoiceType),
        action: "open",
        type: "",
      },
      ...vehicleDataPush,
    });
  }
};

export default openInvoiceModalDataPush;
